//HERBatches.jsx
import { useMemo, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  TablePagination,
  Paper,
  Box,
  Typography,
  Chip,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import { Visibility, ExpandMore } from "@mui/icons-material";
import { BglLoading } from "components/loading/BglLoading";
import "./HERStyles.scss";

const HERBatches = ({
  batches,
  onViewBatch,
  currentPage,
  totalBatches,
  batchesPerPage,
  onPageChange,
  setBatchesPerPage,
  setCurrentPage,
  isLoading,
  error,
}) => {
  const [expanded, setExpanded] = useState(true); // Open by default

  // Sort batches by createdAt in descending order (newest first)
  const sortedBatches = useMemo(() => {
    if (!batches || batches.length === 0) return [];

    return [...batches].sort((a, b) => {
      const dateA = new Date(a.createdAt);
      const dateB = new Date(b.createdAt);
      return dateB - dateA; // Descending order (newest first)
    });
  }, [batches]);

  // Client-side pagination: slice the sorted array to show only current page
  const paginatedBatches = useMemo(() => {
    const startIndex = currentPage * batchesPerPage;
    const endIndex = startIndex + batchesPerPage;
    return sortedBatches.slice(startIndex, endIndex);
  }, [sortedBatches, currentPage, batchesPerPage]);

  const handlePageChange = (_event, newPage) => {
    setCurrentPage(newPage);
    onPageChange(newPage);
  };

  const handleRowsPerPageChange = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setBatchesPerPage(newRowsPerPage);
    setCurrentPage(0);
  };

  return (
    <Accordion
      expanded={expanded}
      onChange={(_, isExpanded) => setExpanded(isExpanded)}
      style={{ marginTop: "16px", padding: "16px" }}
    >
      <AccordionSummary expandIcon={<ExpandMore />}>
        <Typography variant="h6">
          HER Batches {batches && batches.length > 0 ? `(${batches.length})` : ''}
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        {isLoading ? (
          <BglLoading />
        ) : error ? (
          <Typography variant="body1" color="error">
            {error}
          </Typography>
        ) : batches && batches.length > 0 ? (
          <>
            <TableContainer component={Paper} className="her-table">
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Batch ID</TableCell>
                    <TableCell>Pilot ID</TableCell>
                    <TableCell>Batch Size</TableCell>
                    <TableCell>Created At</TableCell>
                    <TableCell>Updated At</TableCell>
                    <TableCell>Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {paginatedBatches.map((batch, index) => (
                    <TableRow key={batch.id || index}>
                      <TableCell>
                        <Typography variant="body2" className="notification-id">
                          {batch.id}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Chip
                          label={batch.pilotId}
                          color={"primary"}
                          size="small"
                        />
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2" fontWeight="bold">
                          {batch.batchSize}
                        </Typography>
                      </TableCell>
                      <TableCell>{batch.createdAt}</TableCell>
                      <TableCell>{batch.updatedAt}</TableCell>
                      <TableCell>
                        <Box sx={{ display: 'flex', gap: 1 }}>
                          <Button
                            size="small"
                            variant="contained"
                            color="primary"
                            startIcon={<Visibility />}
                            onClick={() => onViewBatch(batch)}
                          >
                            View Notifications
                          </Button>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            <TablePagination
              component="div"
              count={totalBatches}
              page={currentPage}
              onPageChange={handlePageChange}
              rowsPerPage={batchesPerPage}
              onRowsPerPageChange={handleRowsPerPageChange}
              rowsPerPageOptions={[5, 10, 25, 50]}
            />
          </>
        ) : (
          <Typography variant="body2" color="textSecondary" align="center">
            No batches found
          </Typography>
        )}
      </AccordionDetails>
    </Accordion>
  );
};

export default HERBatches;

